<template>
  <base-modal modal-id="combo-modifiers" modalSize="lg">
    <template v-slot:header>
      <ItemInfo></ItemInfo>
    </template>
    <template v-slot:modal-body>
      <div class="customized-detail">
        <Modifiers></Modifiers>
      </div>
    </template>
    <template v-slot:modal-footer>
      <Bottom addToCartAction="Add to item" :isCombo="true"></Bottom>
    </template>
  </base-modal>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import ItemInfo from '@/components/Blocks/Cart/Items/ItemDetail/ItemInfo'
import Modifiers from '@/components/Blocks/Cart/Items/ItemDetail/SelectModifiers'
import Bottom from '@/components/Blocks/Cart/Items/ItemDetail/Bottom'
import BaseModal from '@/components/Modals/BaseModal'

export default {
  name: 'ComboModifiers',
  components: {
    ItemInfo,
    Modifiers,
    Bottom,
    BaseModal,
  },
  computed: {
    ...mapState({
      openPopup: state => state.brand_store.openModifier,
      item: state => state.cart_store.selectedItem,
    }),
    ...mapGetters([
      '_T_DB',
      '_T',
      'itemModifierGroups',
      'itemModifierSubGroups',
      'itemModifiers',
    ]),
  },
  data () {
    return {
      // closepopup: false,
      // selectSingleItemClick: '',
    }
  },
  // props: { isModalVisible: Boolean },
  methods: {
    close () {
      this.$store.commit('SET_ITEM_DETAIL_POPUP')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-bottom {
  position: unset;
  max-width: unset;
}
/deep/.customized-title .close {
  display: none;
}
.modifier-side-popup {
  box-shadow: 0 0 $px8 rgba($black, 0.55);
  position: fixed;
  margin: auto;
  right: 0px !important;
  width: $px600 !important;
  max-width: $px600 !important;
  height: 100vh;
  top: 0;
  z-index: 99;
  &.open-popup {
    .sidebar-overlay {
      opacity: 0.5;
    }
  }
  .sidebar-overlay {
    background-color: $black;
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 1s;
    opacity: 0;
  }
  .customized-modal {
    &.show {
      .modal-dialog {
        right: 0 !important;
      }
    }
    &.modal-dialog {
      max-width: 100%;
      margin: 0;
      // @extend %default-scroll-lg;
      .modal-content {
        height: 100vh;
        overflow: auto;
        padding-bottom: $px50;
        border: none;
        border-radius: 0;
        /* width */
        ::-webkit-scrollbar {
          width: $px6;
        }
        /* Track */
        ::-webkit-scrollbar-track {
          background: $scrollbar-track;
          border-radius: $px6;
        }
        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: $scrollbar-thumb;
          border-radius: $px4;
        }
        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: darken($scrollbar-track, 0.2);
        }
      }
    }
    .modal-body {
      padding: 0;
      width: 100%;
      .customized-detail {
        padding: $px20;
        overflow: auto;
        background-color: $white;
        &::-webkit-scrollbar {
          width: 0 !important ;
        }
      }
    }
  }
}
</style>
